import { Pipe, PipeTransform } from '@angular/core';

/**
 * convert the service agreement acceptance value.
 *
 */
@Pipe({ name: 'agreement' })
export class AgreementPipe implements PipeTransform {
    transform(value: boolean): string {
        

        if (value == true) {
            return 'Accepted';
        } else
            return 'Not Accepted';
    }
}